import { Injectable } from '@angular/core';
import { BehaviorSubject, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { ProjectStore } from './project.store';
import { ProjectInfo, ProjectInfoRaw, ProjectType } from '@frontend-site/shared/data';

@Injectable({
    providedIn: 'root'
})
export class ProjectInformationService {
    private projectInfo: ProjectInfo | null | undefined;
    private projectInformationSubject = new BehaviorSubject<ProjectInfoRaw | null>(null);
    projectInformation$ = this.projectInformationSubject.asObservable();

    constructor(private http: HttpClient, private projectStore: ProjectStore) {
        this.projectStore.projectDetails$
            .pipe(
                tap((projectInfo) => {
                    this.projectInfo = projectInfo;
                })
            )
            .subscribe();
    }

    loadProjectInformation(projectId: number): void {
        this.http
            .get<ProjectInfoRaw>(`/rest/pqm/projectInformation`, { params: { projectId: projectId.toString() } })
            .pipe(
                catchError((err) => {
                    console.log('failed loading ProjectInformation', err);
                    this.projectInformationSubject.next(null);
                    return throwError(() => err);
                }),
                tap((projectInfo) => {
                    this.projectInformationSubject.next(projectInfo);
                })
            )
            .subscribe();
    }

    public isIAProject(): boolean {
        const projectType = this.projectInfo?.projectType;
        return (
            projectType === ProjectType.SUPPORT_PACKAGE ||
            projectType === ProjectType.SUPPORT_PACKAGE_NEW ||
            projectType === ProjectType.CLEANSING ||
            projectType === ProjectType.S4_CONVERT ||
            projectType === ProjectType.S4_CONVERT_NEW ||
            projectType === ProjectType.S4_ACCELERATE ||
            projectType === ProjectType.S4_ACCELERATE_NEW ||
            projectType === ProjectType.ICR_3 ||
            projectType === ProjectType.ORACLE_PATCHES ||
            projectType === ProjectType.UPGRADE ||
            projectType === ProjectType.ORACLE_UPGRADE ||
            projectType === ProjectType.ORACLE_ONLINE_PATCHES
        );
    }

    public isS4Project(): boolean {
        const projectType = this.projectInfo?.projectType;
        return (
            projectType === ProjectType.S4_CONVERT ||
            projectType === ProjectType.S4_CONVERT_NEW ||
            projectType === ProjectType.S4_ACCELERATE ||
            projectType === ProjectType.S4_ACCELERATE_NEW ||
            projectType === ProjectType.ICR_3
        );
    }

    public isIcr3Project(): boolean {
        const projectType = this.projectInfo?.projectType;
        return projectType === ProjectType.ICR_3;
    }

    public isCleanCoreProject(): boolean {
        return this.projectInfo?.projectType === ProjectType.CLEAN_CORE;
    }

    public isS4ConvertNewProject(): boolean {
        return this.projectInfo?.projectType === ProjectType.S4_CONVERT_NEW;
    }

    public isS4AccelerateNewProject(): boolean {
        return this.projectInfo?.projectType === ProjectType.S4_ACCELERATE_NEW;
    }

    public isSpsNewProject(): boolean {
        return this.projectInfo?.projectType === ProjectType.SUPPORT_PACKAGE_NEW;
    }

    public isUnifiedProject(): boolean {
        return this.isS4ConvertNewProject() || this.isS4AccelerateNewProject() || this.isSpsNewProject();
    }
}
